
import React, { useEffect, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import { Container, Table, Row, Col } from "react-bootstrap";
import {useLocation, useNavigate } from "react-router-dom";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";

export default function AloUnMappedReport() {
  let navigate = useNavigate();
  const location = useLocation();
  const Data = location?.state?.data;
  const [getpendingMandals, setpendingMandals] = useState([]);
  function GetPendingMandals() {
    let url =  config.url.BOC_URL + "mandals/" + Data?.lgd_dist_code;
    CommonAxiosGet(url).then((res) => {
      if (res.data.status === true) {
        setpendingMandals(res.data);
        for (let i = 0; i < res.data?.mandals?.length; i++) {
          formIk.setFieldValue(
            `alos[${i}].mandal_id`,
            res.data?.mandals[i]?.mandal_code
          );
        }
      }
    });
  }

  let listOfObjects = [];
  let length = getpendingMandals?.mandals?.length;
  for (let i = 0; i < length; i++) {
    if (
      getpendingMandals?.mandals !== undefined &&
      getpendingMandals?.status === true
    ) {
      listOfObjects.push({
        mandal_id: "",
        org_id: "",
      });
    } else {
    }
  }
  const formIk = useFormik({
    initialValues: {
      insert_by: "TestAloDetails",
      alos: listOfObjects,
    },
    
    
  });

  useEffect(() => {
    GetPendingMandals();
  }, []);

  return (
    <>
      <Header/>
      <div className="main_section"> </div>
      <FormikProvider value={formIk}>
        <Form onSubmit={formIk.handleSubmit} onChange={formIk.handleChange}>
          <Container>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="page-titlespacing d-flex justify-content-between"
              >
                <div className="inner-herbpage-service-title1">
                <h1><span style={{color:"brown"}}> {Data?.distname}</span> - ALO  UnMapped Mandals Report</h1>
                </div>
                <div className="text-right">
                  <button type="button" className="btn btn-secondary" onClick={()=>{navigate(-1)}}>Back</button>
                </div>
              </Col>
            </Row>
          </Container>
          <Container className="outer-page-content-container">
            <Row className="px-4">           
              <center>
                <Table
                  className="table table-condensed table-bordered table-striped table-responsive tableex mt-3 mb-5"
                  style={{ alignItems: "center" }}>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>UnMapped Mandals</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getpendingMandals?.mandals &&
                      getpendingMandals?.mandals?.map((data, i) => {
                        return (
                          <tr>
                            <td style={{textAlign:"center"}}>{i + 1}</td>
                            <td style={{textAlign:"center"}}>                             
                              {data.mandal_name}
                            </td>                        
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </center>
            </Row>         
          </Container>
        </Form>
      </FormikProvider>
    </>
  );
}
